import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-write-icon',
  templateUrl: './communication-write.component.html'
})
export class CommunicationWriteComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
